<div class="popup">
  <header class="title">
    <h4>{{ 'ACCOUNT_ADMIN_PICKER.TITLE' | translate }}</h4>
    <ion-button fill="clear" size="small" (click)="dismiss()" aria-label="Close">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </header>

  <p class="hint">{{ 'ACCOUNT_ADMIN_PICKER.HINT' | translate }}</p>

  <ion-list>
    <ion-radio-group [(ngModel)]="selectedAccountId">
      <ion-item *ngFor="let acct of adminAccounts" lines="full">
        <ion-radio slot="start" [value]="acct.id"></ion-radio>
        <ion-label>{{ acct.name }}</ion-label>
      </ion-item>
    </ion-radio-group>
  </ion-list>

  <div class="actions">
    <ion-button expand="block" (click)="confirm()" [disabled]="selectedAccountId == null">
      {{ 'ACCOUNT_ADMIN_PICKER.CONTINUE' | translate }}
    </ion-button>
  </div>
</div>
